import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output, QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewContainerRef
} from "@angular/core";
import { NoDataFoundComponent } from "../no-data-found/no-data-found.component";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";

export interface AccordionData {
  title: string;
  data?: any;
}

@Component({
  selector: 'app-tos-accordion',
  standalone: true,
  imports: [
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatExpansionPanelHeader,
    NoDataFoundComponent
  ],
  templateUrl: './tos-accordion.component.html',
  styleUrl: './tos-accordion.component.scss'
})
export class TosAccordionComponent {
  @Input() title: string = "";
  @Input() accordionData:  AccordionData[]= [];

  @ViewChildren("accordionContent", { read: ViewContainerRef }) accordionContents!: QueryList<ViewContainerRef>;

  @Output() accordionOpenedEmitter = new EventEmitter<{index: number,rowData: any}>();

  constructor(private cdr: ChangeDetectorRef) {}

  loadComponent(component: any, rowIndex: number, data?: Partial<any>) {
    const viewContainerRef = this.accordionContents.toArray()[rowIndex];
    viewContainerRef.clear();

    if (component instanceof  TemplateRef) {
      return viewContainerRef.createEmbeddedView(component, { $implicit: data });
    } else {
      const componentRef = viewContainerRef.createComponent(component);
      if (componentRef.instance && data) {
        Object.assign(componentRef.instance, data);
        componentRef.changeDetectorRef.detectChanges();
      }
      return componentRef
    }
  }
}
